import { openMailto } from "@/utils/mailto";
import Hero from "../components/hero";
import { CorporateGovernancePage } from "@features/general";
import heroImage from "@assets/images/governance-hero.svg";

const heroData = {
  title: "Governance Built on Safety. Compliance Anchored in Integrity.",
  description:
    "At Gas Integrated Solutions L.L.C. (GASIS), we operate under the highest safety, regulatory, and ethical standards. Our governance framework ensures transparency, accountability, and full compliance with UAE laws, Dubai Civil Defense, ESMA requirements, and international best practices",
  image: heroImage,
  footerText:
    "Our licensed technicians and 24/7 emergency solutions team are always ready to protect your home and business.",
  footerButtonText: "Talk to Our Team",
  footerButtonOnclick: () => openMailto({ subject: "Corporate Governance Inquiry" }),
};

function CorporateGovernance() {
  return <CorporateGovernancePage hero={<Hero data={heroData} />} />;
}

export default CorporateGovernance;
